/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSubjectStatus.defs.js'
export * as $defs from './getSubjectStatus.defs.js'
